import React from "react";
import { Box, Text } from "@chakra-ui/react";

type Registration = {
  status: string;
  next_attempt_at?: string;
};

export default function RegistrationStatus({ registration }: { registration?: Registration | null }) {
  if (!registration) return null;
  const labels: Record<string, string> = {
    pending: "Pending — saved for automatic retry",
    processing: "Pending — confirming registration",
    registered: "Registered — account confirmed",
    needs_attention: "Needs attention — registration is not confirmed. See Review Queue.",
    cancelled: "Cancelled — automatic registration stopped",
  };
  if (!labels[registration.status]) return null;
  const retry = registration.status === "pending" && registration.next_attempt_at
    ? new Date(registration.next_attempt_at) : null;
  return (
    <Box px={4} py={2} borderBottomWidth="1px" role="status" aria-label="Registration status">
      <Text fontSize="sm"><strong>Registration: </strong>{labels[registration.status]}</Text>
      {retry && !Number.isNaN(retry.getTime()) && (
        <Text fontSize="xs">Next retry from {retry.toLocaleString("en-GB", { timeZone: "Africa/Lagos" })} (Lagos)</Text>
      )}
    </Box>
  );
}
